import React from 'react';

const COLORS = [
    '#e57373', '#f06292', '#ba68c8', '#9575cd', '#7986cb',
    '#64b5f6', '#4fc3f7', '#4dd0e1', '#4db6ac', '#81c784',
    '#aed581', '#dce775', '#ffb74d', '#ff8a65', '#a1887f'
];

const getHashCode = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
};

const getColor = (phone) => {
    const hash = getHashCode(phone || '');
    return COLORS[Math.abs(hash) % COLORS.length];
};

const getInitials = (name, phone) => {
    if (name && typeof name === 'string') {
        return name.charAt(0).toUpperCase();
    }
    if (phone && typeof phone === 'string') {
        return phone.slice(-2);
    }
    return '?';
};

export default function Avatar({ src, name, phone, size = 'md' }) {
    const initials = getInitials(name, phone);
    const color = getColor(phone);

    const sizePx = {
        sm: 24,
        md: 40,
        lg: 48
    }[size] || 40;

    const style = {
        width: sizePx,
        height: sizePx,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: color,
        color: '#fff',
        fontWeight: 'bold',
        fontSize: size === 'sm' ? '12px' : '16px',
        overflow: 'hidden',
        flexShrink: 0,
        userSelect: 'none'
    };

    if (src) {
        return (
            <div style={style} className="yc-avatar">
                <img
                    src={src}
                    alt={name || phone}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={(e) => { e.target.style.display = 'none'; }}
                />
            </div>
        );
    }

    return (
        <div style={style} className="yc-avatar" title={name || phone}>
            {initials}
        </div>
    );
}
